<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.commissioningRate.title"
                        [body]="{
                            value: kpi.commissioningRate,
                            precision: texts.commissioningRate.precision,
                            suffix: texts.commissioningRate.suffix,
                        }"
                        [descriptionTitle]="texts.commissioningRate.description.title"
                        [descriptionContent]="texts.commissioningRate.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'commissioningRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.unpaidDisconnectionCount.title"
                        [body]="{
                            value: kpi.unpaidDisconnectionCount,
                            precision: texts.unpaidDisconnectionCount.precision,
                        }"
                        [descriptionTitle]="texts.unpaidDisconnectionCount.description.title"
                        [descriptionContent]="texts.unpaidDisconnectionCount.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'unpaidDisconnectionCount')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>
        </div>
    </div>
</div>
